"use strict";

exports.__esModule = true;
exports.auditLogWidgets = void 0;
var _Components = require("../Components");
var auditLogWidgets = exports.auditLogWidgets = function auditLogWidgets() {
  return [_Components.DataTableWidget, _Components.DataTableColumnWidget, _Components.ReportWidget];
};